import * as Yup from 'yup'
import { INewEmployee } from './newEmployee.types'
import { ROLE } from '../../../auth'

// Роли, которым мерчант выбирается одиночным селектом (в отличие от мульти-выбора
// у merchant_payments_operator / merchant_manager). Бэкенд требует merchantId для всех них.
export const ROLES_WITH_SINGLE_MERCHANT = [
  ROLE.ROLE_MATCHING_OPERATOR,
  ROLE.ROLE_OPERATOR,
  ROLE.ROLE_SENIOR_OPERATOR,
]

export const NEW_EMPLOYEE_SCHEMA = Yup.object().shape({
  uuid: Yup.string().required('Обязательное поле'),
  password: Yup.string().required('Обязательное поле').min(6, 'Пароль должен содержать не менее 6 символов'),
  role: Yup.string().required('Обязательное поле'),
  merchantId: Yup.number().when('role', {
    is: (role: string) => ROLES_WITH_SINGLE_MERCHANT.includes(role as ROLE),
    then: (schema) => schema.required('Обязательное поле для данной роли'),
    otherwise: (schema) => schema.nullable(),
  }),
  merchantIds: Yup.array().of(Yup.number()).when('role', {
    is: (role: string) => [ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER].includes(role as ROLE),
    then: (schema) => schema.min(1, 'Выберите хотя бы одного мерчанта'),
    otherwise: (schema) => schema.nullable(),
  }),
})

export const DEFAULT_NEW_EMPLOYEE_OBJ: INewEmployee = {
  uuid: '',
  password: '',
  role: '',
  merchantIds: [],
}

export const ROLES_FOR_NEW_EMPLOYEE = [
  ROLE.ROLE_ADMIN,
  ROLE.ROLE_CASHIER,
  ROLE.ROLE_SENIOR_CASHIER,
  ROLE.ROLE_MANAGER,
  ROLE.ROLE_OPERATOR,
  ROLE.ROLE_SENIOR_OPERATOR,
  ROLE.ROLE_MATCHING_OPERATOR,
  ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
]

export const ROLES_FOR_CASHBOX = [
  ROLE.ROLE_CASHIER,
  ROLE.ROLE_SENIOR_CASHIER,
]

export const ROLES_FOR_MERCHANT = [
  ROLE.ROLE_OPERATOR,
  ROLE.ROLE_SENIOR_OPERATOR,
  ROLE.ROLE_MATCHING_OPERATOR,
  ROLE.ROLE_MERCHANT_PAYMENTS_OPERATOR, ROLE.ROLE_MERCHANT_MANAGER,
]
